module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.bannerPlaceHolderForFireWorkStoryBlock &&
    _vm.bannerPlaceHolderForFireWorkStoryBlock.tag_text && _vm.widgetType &&
    _vm.bannerPlaceHolderForFireWorkStoryBlock.tag_text.toLowerCase() === _vm.widgetType.toLowerCase()) ? _c('FireWork') : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderForFireWorkGrid &&
    _vm.bannerPlaceHolderForFireWorkGrid.tag_text && _vm.widgetType &&
    _vm.bannerPlaceHolderForFireWorkGrid.tag_text.toLowerCase() === _vm.widgetType.toLowerCase()) ? _c('FireWork', {
    attrs: {
      "fireWorkType": "gridFeed"
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ee5203c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeWidgetsWrapper.vue
// module id = 2448
// module chunks = 107